package com.fireavert.administration.super_admin_tools_page.data_models.requests

import com.fireavert.events.shared.data_models.models.ReportFrequency
import kotlinx.serialization.Serializable

@Serializable
data class TestEmailReportRequest(
    val email: String,
    val propertyId: Int,
    val emailType: ReportFrequency
)
